package top.wcpe.allincore.ui.runtime.style

import top.wcpe.allincore.ui.runtime.render.model.MaskType
import kotlin.jvm.JvmName

/**
 * 表面遮罩：SDF 裁剪形状（矩形 / 圆 / 波浪 / 扇形及其反相），由 [VisualModifier.Surface] 持有。
 *
 * 与 [Brush] 同为 Surface 的值类型，把散落的 mask* 字段收敛为一个值——遮罩意图独立表达。
 * [type] 为 [MaskType.NONE] 时等价于无遮罩。[param1]/[param2]/[param3] 的含义由各 MaskType 的 shader 解释。
 */
data class Mask(
    @get:JvmName("type") val type: MaskType,
    @get:JvmName("param1") val param1: Float = 0f,
    @get:JvmName("param2") val param2: Float = 0f,
    @get:JvmName("param3") val param3: Float = 0f,
) {
    /** 是否为可见遮罩（[type] 非 [MaskType.NONE]）。 */
    fun isActive(): Boolean = type != MaskType.NONE
}
